<button class="valben-dialog-close" mat-dialog-close aria-label="Zatvori">
    <mat-icon>close</mat-icon>
</button>

<h2 mat-dialog-title class="text-lg font-semibold pr-10">Podaci o najmodavcu</h2>

<mat-dialog-content class="!max-h-[75vh]">
    <div class="flex flex-col gap-4 bg-[#f3f4f8] border-2 static p-4">

        @if (!hasData && !editMode) {
            <p class="text-lg">
                Podaci o najmodavcu nisu podneseni.
            </p>
        }

        @if (hasData || editMode) {
            <valben-text-input
                [key]="landlordDataKeys.Name"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordName"
                title="Ime"
                [error]="modifyLandlordDataErrors[landlordDataKeys.Name]"
                [preview]="!editMode">
            </valben-text-input>

            <valben-text-input
                [key]="landlordDataKeys.Surname"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordSurname"
                title="Prezime"
                [error]="modifyLandlordDataErrors[landlordDataKeys.Surname]"
                [preview]="!editMode">
            </valben-text-input>

            <valben-text-input
                [key]="landlordDataKeys.PhoneNumber"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordPhoneNumber"
                title="Broj mobitela"
                [error]="modifyLandlordDataErrors[landlordDataKeys.PhoneNumber]"
                [preview]="!editMode">
            </valben-text-input>

            <valben-text-input
                [key]="landlordDataKeys.Email"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordEmail"
                title="E-mail"
                [error]="modifyLandlordDataErrors[landlordDataKeys.Email]"
                [preview]="!editMode">
            </valben-text-input>

            <valben-text-input
                [key]="landlordDataKeys.OIB"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordOIB"
                title="OIB"
                [error]="modifyLandlordDataErrors[landlordDataKeys.OIB]"
                [preview]="!editMode">
            </valben-text-input>

            <valben-text-input
                [key]="landlordDataKeys.Iban"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordIban"
                title="IBAN za uplatu najma"
                [error]="modifyLandlordDataErrors[landlordDataKeys.Iban]"
                [preview]="!editMode"
                placeholder="HR12 1001 0051 8630 0016 0">
            </valben-text-input>

            @if (showSwift) {
                <valben-text-input
                    [key]="landlordDataKeys.Swift"
                    [itemObservable]="modifyLandlordData"
                    [update]="updateEditLandlordSwift"
                    title="Swift kod banke"
                    [error]="modifyLandlordDataErrors[landlordDataKeys.Swift]"
                    [preview]="!editMode">
                </valben-text-input>
            }

            <valben-address-input
                [key]="landlordDataKeys.ResidenceAddress"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordResidenceAddress"
                title="Adresa stanovanja"
                [error]="modifyLandlordDataErrors[landlordDataKeys.ResidenceAddress]"
                [preview]="!editMode">
            </valben-address-input>

            <valben-file-input
                class="landlord-file-input"
                [key]="landlordDataKeys.ConsentForm"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordConsentForm"
                title="Privola za unos podataka najmodavca"
                fileType="application/pdf"
                [error]="modifyLandlordDataErrors[landlordDataKeys.ConsentForm]"
                [optional]="false"
                [isKng]="true"
                [preview]="!editMode">
            </valben-file-input>

            <p class="m-0 font-bold" style="font-size: 24px; line-height: 1.2;">
                Podaci o stanu koji se izdaje u najam
            </p>

            <valben-file-input
                class="landlord-file-input"
                [key]="landlordDataKeys.OwnershipCertificate"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordOwnershipCertificate"
                title="Vlasnički list"
                fileType="application/pdf"
                [error]="modifyLandlordDataErrors[landlordDataKeys.OwnershipCertificate]"
                [optional]="false"
                [isKng]="true"
                [preview]="!editMode">
            </valben-file-input>

            <valben-text-input
                [key]="landlordDataKeys.CatastarKO"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordCatastarKO"
                title="Katastarska općina"
                [error]="modifyLandlordDataErrors[landlordDataKeys.CatastarKO]"
                [preview]="!editMode">
            </valben-text-input>

            <valben-text-input
                [key]="landlordDataKeys.CatastarCE"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordCatastarCE"
                title="Katastarska čestica"
                [error]="modifyLandlordDataErrors[landlordDataKeys.CatastarCE]"
                [preview]="!editMode">
            </valben-text-input>

           <valben-rooms-input
                [key]="landlordDataKeys.PropertyRooms"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordPropertyRooms"
                title="Broj soba"
                [error]="modifyLandlordDataErrors[landlordDataKeys.PropertyRooms]"
                [preview]="!editMode">
            </valben-rooms-input>

            <valben-number-input
                [key]="landlordDataKeys.AreaOfProperty"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordAreaOfProperty"
                title="Površina stana u m2"
                [error]="modifyLandlordDataErrors[landlordDataKeys.AreaOfProperty]"
                [preview]="!editMode">
            </valben-number-input>

            <valben-address-input
                [key]="landlordDataKeys.RentalPropertyAddress"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordRentalPropertyAddress"
                title="Adresa nekretnine u najmu"
                [error]="modifyLandlordDataErrors[landlordDataKeys.RentalPropertyAddress]"
                [preview]="!editMode">
            </valben-address-input>

            <valben-number-input
                [key]="landlordDataKeys.MonthlyRent"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordMonthlyRent"
                title="Mjesečna najamnina"
                [error]="modifyLandlordDataErrors[landlordDataKeys.MonthlyRent]"
                [preview]="!editMode">
            </valben-number-input>

            <valben-boolean-input
                [key]="landlordDataKeys.IsApartmentOfLegalEntity"
                [itemObservable]="modifyLandlordData"
                [update]="updateEditLandlordIsApartmentOfLegalEntity"
                title="Stan je u vlasništvu pravne osobe"
                [error]="modifyLandlordDataErrors[landlordDataKeys.IsApartmentOfLegalEntity]"
                [preview]="!editMode">
            </valben-boolean-input>
        }

        <div class="flex gap-4 justify-end items-center select-none mt-4">
            @if (!editMode && hasData) {
                <button class="valben-button" (click)="startEdit()">
                    Uredi
                </button>
            }
            @if (!editMode && !hasData) {
                <button class="valben-button" (click)="startEdit()">
                    Unesi podatke
                </button>
            }
            @if (editMode) {
                <button class="valben-button" (click)="cancelEdit()">
                    Odustani
                </button>
            }
            @if (editMode) {
                <button class="valben-button" (click)="save()">
                    Spremi promjene
                </button>
            }
        </div>
    </div>
</mat-dialog-content>
